import { toHttps } from '../url';

function normalizeImageUrl(url: string): string {
  return toHttps(url);
}

export default normalizeImageUrl;
